import axios from 'axios';
import * as envConfig from 'config';

export default axios.create({
    baseURL: envConfig.HOST_URL,
});